import React, {useState} from "react";
import Sidebar from '../Sidebar'
// import env from 'react-dotenv'

export const CropCalendarForm = ()=>{
    const [formData, setFormData] = useState({
        event:"",
        start:null,
        end:null
    })

     //submission handler
  const handleSubmit = async (e) =>{
    e.preventDefault()
    const token = sessionStorage.getItem('token')
    const response = await fetch(`${process.env.REACT_APP_API_URL}/create-crop-calendar`, {
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body:JSON.stringify(formData)
    })
        // .then(console.log(formData))
        // .then(console.log("Successfully submitted!"))
  
  }

    return(
        <>
        <div className="sidebar">
    <Sidebar/>
  </div>
  <div id="tabler">
  <form onSubmit={handleSubmit}>
  <h1>Crop Calendar Form</h1>
  <label for="formGroupExampleInput" class="form-label">Event Name</label>
        <div class="input-group mb-3">
        
        <input type="text" onChange={(e)=>{
            setFormData({...formData, event:e.target.value})
        }} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
        </div>


        <label for="formGroupExampleInput" class="form-label">Start</label>
        <div class="input-group mb-3">
        <input type="date" onChange={(e)=>{
            setFormData({...formData, start:e.target.value})
        }} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
        </div>


        <label for="formGroupExampleInput" class="form-label">End</label>
        <div class="input-group mb-3">
        <input type="date" onChange={(e)=>{
            setFormData({...formData, end:e.target.value})
        }} class="form-control" aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
        </div>

        <button type="submit"  className="btn submit-btn" onClick={handleSubmit}>Submit</button>
        </form>

  </div>
       
        </>
    )
}